module.exports = __webpack_public_path__ + "static/kw51_img_5-e8fbc23679e64e57af4b2c27bc1a9540.png";